// Override Settings
var bcSfSearchSettings = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

// Get Search Term value
BCSfFilter.prototype.getSearchTerm = function() {
  var term = getParam(this.searchTermKey);
  if(term && (term.includes('&apos;') || term.includes('&quot;'))) {
    return term.replace(/&apos;/g, "'").replace(/&quot;/g, "'");
  }
  return term;
};

BCSfFilter.prototype.afterBuildSearchBox = function(e) {
  $(e).attr('placeholder', theme.search_placeholder);
}

/* Start-Boost-227188 */
/* remove case sensitivity from search */
BCSfFilter.prototype.getSearchRedirectUrl = function (searchTerm) {
    var redirectUrl = '';
    if (searchTerm) {
        if (typeof searchTerm !== 'string'){
            searchTerm = searchTerm.toString();
        }
        searchTerm = searchTerm.trim();
        if (this.suggestionCache.hasOwnProperty(searchTerm) || this.suggestionCache.hasOwnProperty(searchTerm.toLowerCase())) {
            var cachedResult = this.suggestionCache[searchTerm];
            for (var i = 0; i < cachedResult.length; i++) {
                if (cachedResult[i].key == 'redirect' && cachedResult[i].values) {
                    // Check is there is a redirect
                    redirectUrl = cachedResult[i].values;
                    redirectUrl = redirectUrl.replace('https://' + bcSfFilterMainConfig.shop.domain, '');
                    redirectUrl = redirectUrl.replace('http://' + bcSfFilterMainConfig.shop.domain, '');    
                }
            }
        }
    }
    return redirectUrl;
};
/* End-Boost-227188 */
